// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scene_Frame__-11cT {
  height: 1000px; 
}

.Scene_SubTitleGreySilver__9Ppgr {
  background-color: #7a7d7d;
  background-color: #868889;
  font-weight: 700;
  color: #fff;
}

.Scene_SubTitleG__Ad4Eo {
  background-color: #5a9fa9;
  font-weight: 700;
  color: #fff;
}

.Scene_SubTitleScene__P-Pbj {
  background-color: #39606e;
  font-weight: 700;
  color: #fff;
}

.Scene_SubTitleGreyBlue__qrgma {
  background-color: #546c88;
  font-weight: 700;
  color: #fff;
}

.Scene_SubTitle__gZeDJ {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Scene_Red2__8K7YA {
  color: red;
}

.Scene_SceneCard__9uuoo {
  margin: auto;
  border: 1px solid #cef3f8;
  background-color: #39606e;
  color: #fff;
}

.Scene_SceneCard__9uuoo:hover {
  background-color: #1ea7ae;
}

.Scene_WhiteForm__0CMc5 {
  background-color: #fff;
  border-left: 1px solid rgba(129, 102, 21, 0.99);
  border-right: 1px solid rgba(129, 102, 21, 0.99);
  border-bottom: 1px solid rgba(129, 102, 21, 0.99);
  border-top: 1px solid rgba(129, 102, 21, 0.99);
}

.Scene_SubTitleBlack__OqPRS{
  background-color: #000;
  color: #fff;
  font-weight: 700;
}

.Scene_Role__StIJH {
  color: #494d70;
}

.Scene_Camera1__Q-4YW {
  color: #8b0f87;
  font-size: 1.4rem;
  font-weight: 700;
}
.Scene_Camera2__i-vhf {
  color: hsl(270, 94%, 33%);
  font-size: 1.4rem;
  font-weight: 700;
}

.Scene_BoldTitle__XPwUP {
  font-weight: 700;
  background-color: #d6fcff;
}

.Scene_BoldTitle2__i0IBb {
  font-weight: 700;
  border-right : 3px solid #fafafa;
  background-color: #d6fcff;
}

.Scene_BoldTitle3__K\\+8eK {
  font-weight: 700;
  background-color: #d6fcff;
}

.Scene_MoodTopRow__bMKlP {
  height: 60px;
  overflow: hidden;
}

.Scene_Icon__bg4qX i {
  font-size: .6rem;
}

.Scene_Datetext__OEZnu {
  background-color: #000;
  color: #fff;
}

.Scene_Date2__UV3KN {
  font-size: .6rem;
}

.Scene_SceneCard__9uuoo i {
  color: #fff;
}

.Scene_Italics__HXF9b {
    font-style: italic;
    color: #fff;
  }

.Scene_Grey__lxsQc {
color: #fff;
}

.Scene_Grey2__B2GZo {
color: #fff;
font-weight: 700;
}

.Scene_Grey3__l6Ojj {
color: #fff;
font-weight: 700;
}

.Scene_Grey4__pVzki {
color: #fff;
font-style: italic;
font-weight: 700;
font-size: .85rem;
}

.Scene_Div60__ya3D\\+ {
    height: 60px;
    overflow: hidden;
  }

  .Scene_Div50__te6Ga {
    height: 50px;
    overflow: hidden;
  }

  .Scene_Div30__wZHOf {
    min-height: 30px;
    overflow: hidden;
    color: #494d70;
  }

  .Scene_Div10__GHiSc {
    height: 10px;
    overflow: hidden;
  }

  .Scene_Div20__i0JW4 {
    height: 20px;
    overflow: hidden;
  }

  .Scene_Div25__NETU6 {
    height: 25px;
    overflow: hidden;
  }

  .Scene_Action2__6-SnN {
    color: rgb(54, 52, 52);
    font-style: italic;
  }

.Scene_WhiteReq__EBu4y {
  background-color: #fff;
  color: rgb(140, 111, 25, 99%);
  font-weight: 700;
  font-size: .75rem;
  border-radius: 25px;
  background-color: #39606e;
  color: #fff;
}

.Scene_Read__HDtQr {
  color: rgb(140, 111, 25, 99%);
  color: #000;
  color: #fff;
}

.Scene_BreakTitle__ZZ2Jh {
  border-top: 10px solid #e8f0f1;
}

.Scene_Number__Wi8g5 {
  font-weight: 400 !important;
  font-style: italic;
}

.Scene_Red__KGXIJ {
  color: #00d1ff;
}

.Scene_SubTitle6__DYcz3 {
    background-color: #010f13;
    padding: 20px;
    color: #fff;
    font-size: 1.25rem;
}

.Scene_Dept__1vLSt {
  cursor: pointer;
  border: 5px solid #fff;
  background-color: rgb(228, 245, 250);
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
  margin-top: 20px;
  border: 1px solid rgb(140, 111, 25, 99%);
  background-size: contain;
  height: 125px;
}

/* .GoToScene:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
} */

.Scene_Title__3FAEL {
  font-size: 1em;
}

.Scene_White2__\\+Nqif {
  color: #fff;
}

.Scene_WhiteText__gB51s {
  color: #fff;
  font-size: .70rem;
}

.Scene_Small__oVQlB {
  font-size: .65rem;
  color: #1da3aa;
  font-style: italic;
}

.Scene_SmallInfo__kDEwe {
  font-size: .75rem;
  font-style: italic;
}

.Scene_SmallDepts__NJqXA {
  font-size: .8rem;
  font-weight: 700;
  color: #1da3aa;
  font-style: italic;
}

.Scene_CardBox2__ZXGWP {
  margin-top: 20px;
  border: 1px solid rgb(140, 111, 25, 99%);
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
  background-size: contain;
}

.Scene_CardBox3__Wqs0q {
  margin-top: 20px;
  border: 2px solid aqua;
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Scene_GoldRead__48Mzm {
  color: rgb(140, 111, 25, 99%);
  font-size: .75rem;
  background-color: #fff;
}

.Scene_BlackRead__FHkui {
  background-color: #000;
  color: #fff;
  font-size: .75rem;
}

.Scene_WhiteRead__6esE7 {
  background-color: #fff;
  color: rgb(140, 111, 25, 99%);
  color: #000;
  font-size: .75rem;
}

.Scene_Open__KBSKh {
  background-color: #fff;
  color: rgb(140, 111, 25, 99%);
  font-size: .75rem;
  font-weight: 700;
}

.Scene_BlueReq__FkQV7 {
  background-color: #fff;
  color: #000;
  font-weight: 700;
  font-size: .75rem;
}

.Scene_WhiteReq__EBu4y:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

.Scene_WhiteBackReq__SYUy7 {
  background-color: #fff;
  color: rgb(31, 202, 202);
  font-weight: 700;
  font-size: .75rem;
}

.Scene_WhiteBackReq__SYUy7:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

.Scene_AquaReq__mYelO {
  background-color: aqua;
  color: rgb(140, 111, 25, 99%);
  font-weight: 700;
  font-size: .75rem;
}

.Scene_AquaReq__mYelO:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

.Scene_AquaWork__ZkklM {
  background-color: rgb(120, 240, 240);
  color: rgb(140, 111, 25, 99%);
  font-weight: 700;
  font-size: .75rem;
}

.Scene_AquaWork__ZkklM:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

.Scene_AquaFin__w0aOe {
  background-color: aqua;
  color: rgb(140, 111, 25, 99%);
  font-weight: 700;
  font-size: .75rem;
}

.Scene_AquaFin__w0aOe:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

.Scene_BlackReq__h\\+7EQ {
  background-color: #212529;
  color: #fff;
  font-size: .75rem;
}

.Scene_BlackReq__h\\+7EQ:hover {
  background-color: #fff;
  color: #000;
  cursor: pointer;
}

.Scene_BlackWor__Mw\\+z5 {
  background-color: #2f363c;
  color: #fff;
  font-size: .75rem;
}

.Scene_BlackWor__Mw\\+z5:hover {
  background-color: #fff;
  color: #000;
  cursor: pointer;
}

.Scene_BlackFin__9rVuI {
  background-color: #3b444b;
  color: #fff;
  font-size: .75rem;
}

.Scene_Blackfin__Hw-Xq:hover {
  background-color: #fff;
  color: #000;
  cursor: pointer;
}

.Scene_InfoBack__I1oqL {
  background-color: #fff;
}

.Scene_InfoBack__I1oqL p {
  font-size: .75rem;
}

.Scene_Italic__ETQx3 {
  font-style: italic;
}

.Scene_Rolem__Llfyx {
  color: #747686;
}

.Scene_ViewScript__dPgWb {
  color: rgb(31, 203, 203);
  font-style: italic;
}

.Scene_ViewScript__dPgWb:hover {
  color: #228087;
  cursor: pointer;
}

.Scene_Para__cgPgm {
  min-height: 25px;
}

.Scene_Para2__GsL23 {
  font-size: .75rem !important;
  color: rgb(140, 111, 25, 99%) !important;
}

.Scene_BoldSceneLight__odtI9 {
  color: rgb(140, 111, 25, 99%);
}

.Scene_BoldScene__TqC1g {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.Scene_BoldSceneI__EYXP\\+ {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
  font-style: italic;
}

.Scene_Input__tf1wQ {
  background: #ffffff;
  /* border: 1px solid #e0e3eb;
  border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0px 10px;
  height: 30px !important;
  text-align: center;
  color: #494d70;

}

.Scene_InputEx__E92Xz {
  background: #ffffff;
  /* border: 1px solid #dee1f7;
  border: 1px solid #c1f1f7; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 30px;
  height: 30px !important;
  text-align: center;
  color: #494d70;
}

.Scene_InputScene__7ixEj {
 /* background: #ffffff;
 border: 1px solid #c1f1f7; */
 border-bottom: 1px #00d1ff solid;
 border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 padding: 0px 10px;
 text-align: center;
 min-height: 30px !important;
 color: #494d70;
}

.Scene_InputGuide__gpT\\+B {
 background: #ffffff;
 /* border: 1px solid #e0e3eb; */
 border-bottom: 1px #00d1ff solid;
 border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 padding: 0px 10px;
 min-height: 30px !important;
 color: #494d70;
}

.Scene_InputChar__N4a2n {
 background: #ffffff;
 /* border: 1px solid #e0e3eb; */
 border-bottom: 1px #00d1ff solid;
 border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
 box-sizing: border-box;
 border-radius: 2px;
 padding: 0px 0px;
 height: 30px !important;
 text-align: center;
 color: #494d70;
}

.Scene_InputArea__pVpN8 {
background: #ffffff;
  /* border: 1px solid #e0e3eb; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0px 10px;
  height: 50px !important;
  text-align: center;
  color: #494d70;
}

.Scene_InputBar__zoQvD {
  background: #ffffff;
  border: 1px solid #e0e3eb;
  box-sizing: border-box;
  border-radius: 20px;
  color: #494d70;
  padding: 0px 10px;
  margin-bottom: 16px;
  height: 30px !important;
}

.Scene_InputCharEdit__HZIqB {
  background: #ffffff;
  /* border: 1px solid #e0e3eb; */
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 0px 10px;
  height: 25px !important;
  text-align: center;
  color: #494d70;
} 

.Scene_BoldBlack__Dm8zg {
  color: #000;
  font-weight: 700;
}

.Scene_Back__B4d23 {
  background-color: #fff;
}

.Scene_Back1__UT6tY {
  background-color: #ddf3f8;
}

.Scene_Break__N3xFF {
  border-top: 10px solid #d0d9db;
}

.Scene_BreakBlack__vEpN9 {
  border-top: 5px solid #000;
}


.Scene_XXX__Uq8zF {
  border-top: 5px solid #edc380;
  border-top: 5px solid rgb(232, 246, 231);
  border-top: 5px solid rgb(178, 186, 191);
}

.Scene_Break1__bsFDh {
  border-top: 1px solid #d0d9db;
}

.Scene_Break2__xxVU5 {
  border-top: 5px solid #d0d9db;
}

.Scene_Break3__Daeib {
  border-top: 1px solid #c1f1f7;
}

.Scene_BorderRight__P4wN6 {
  border-right: 1px solid #a7e9f2;
}

.Scene_ColHeight__tCJza {
  min-height: 88.8px;
}

.Scene_DeptImageBox__se\\+\\+n {
  background-color: #000;
  color: #fff;
  font-size: .60rem;
}

.Scene_DeptImageBox__se\\+\\+n:hover {
  background-color: #fff;
  color: #000;
  cursor: pointer;
}

.Scene_TitleBox__wXjcQ {
  background-color: #e8f0f1;
  color: #333;
}

.Scene_TitleBox2__CVvur {
  border-right : 2px solid #fafafa;
  color: #333;
}

.Scene_TitleBox3__xLVOZ {
  border-left : 1px solid #72dbe2;
  border-bottom : 1px solid #72dbe2;
  color: #333;
  font-weight: 700;
}

.Scene_TitleBox4__ngdZ1 {
  border-left : 1px solid #72dbe2;
  border-right : 1px solid #72dbe2;
  border-bottom : 1px solid #72dbe2;
  color: #333;
  font-weight: 700;
}

.Scene_TitleBox4__ngdZ1 i {
  color: #333;
  font-weight: 700;
}

.Scene_TitleBox5__5ZaTf {
  border-bottom : 1px solid #72dbe2;
  color: #333;
}

.Scene_Images__Ar2Sv {
  object-fit: cover;
  height: 200px;
  width: 100%;
}

.Scene_White__C3JKf {
  background-color: #fff;
  min-height: 30px;
}

.Scene_Crimson__G8TQN {
  color: rgb(231, 64, 97);
}

.Scene_Header__YTrAY {
  background-color: #fff;
}

.Scene_Header__YTrAY i {
  color: #666;
}

.Scene_AddScene__jxpFi {
  background-color: cornsilk;
}

.Scene_Bold__QLnGP { 
  font-weight: 700;
}

.Scene_Lightgrey__xmJvu {
  color: rgba(0, 0, 0, .54) 
}

.Scene_ButtonLine__irHS3 {
  background-color: #fff;
  border-top: 3px solid #fff;
}

.Scene_CharactersTitle__RLjMs {
  color: rgb(40, 189, 189);
  font-style: italic;
}

.Scene_CharactersTitle2__\\+8SxA {
  color: rgb(36, 125, 125);
  font-style: italic;
}

.Scene_Actor__aYR2- {
  background-color: rgb(227, 246, 246);
  min-height: 65px;
}

.Scene_Close__XFP2T {
  color: rgb(32, 201, 201);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.Scene_Close__XFP2T:hover {
  color: rgb(10, 66, 66);
}

.Scene_Crimson__G8TQN {
  color: crimson;
}

.Scene_Blue__ap1Rd {
  color: rgb(50, 204, 204);
}

.Scene_Close__XFP2T:hover {
  color: rgb(0, 8, 8);
}

.Scene_CloseIns__V6T4z {
  color: red;
}

.Scene_CloseIns__V6T4z:hover {
  color: rgb(231, 226, 226);
}

.Scene_BreakBox__-xSmE {
  border:1px solid aquamarine;
  min-height: 100px;
}

.Scene_BreakBoxTitle__DyK7s {
  color: crimson;
}

.Scene_Titlex__jMQs3 {
  color: #0052cc;
}

.Scene_SubTitlex__fadt4 {
  background-color: #e1ecec;
  font-weight: 700;
  color: rgba(0, 0, 0, .54)
}

.Scene_SubTitleMood__CdMBQ {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Scene_SubTitle2__29NFV   {
  background-color: #d6fcff;
  font-weight: 700;
}

.Scene_SubTitle3__MZc2X {
  background-color: #e4f2f4;
  font-weight: 700;
}

.Scene_GuideTitle__dkGlL {
  font-style: italic;
  background-color: #e8f0f1;
  color: #104b53;
}

.Scene_GuideText__Qz7QU {
  font-style: italic;
  color: #24a7b8;
}

.Scene_Guide__UROP9 {
  background-color: #fff;
  min-height: 80px;
}

/* .Button {
  color: rgb(10, 173, 173);
}

.Button:hover {
  color: rgb(9, 182, 182);
} */

.Scene_Button__lgYiv {
  color: rgb(7, 111, 111);
  font-weight: 700;
  cursor: pointer;
}

.Scene_Button__lgYiv:hover {
  color: rgb(2, 38, 38);
  font-weight: 700;
}

.Scene_Instructions__L79P5 {
  background-color: aliceblue;
}

.Scene_UniImg__Ng6Dz {
  max-height: 130px;
  cursor: pointer;
}

.Scene_CardBox__e7RKL {
  margin-top: 20px;
  border: 1px solid #fff;
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Scene_CardBox__e7RKL:hover {
  border: 1px solid rgb(255, 255, 255);
  transform: scale(1.1); 
}

.Scene_CostumeLink__UwAf2 {
  color: rgb(26, 172, 172);
  text-transform: uppercase;
  cursor: pointer;
}

.Scene_CostumeLink__UwAf2:hover {
  color: rgb(228, 103, 72);
}
  
  .Scene_SearchIcon__CEZZX {
    position: absolute;
    font-size: 1.2rem;
    padding: 9px;
    padding-left: 15px;
  }
  
  .Scene_SearchIcon__CEZZX:hover {
    cursor: default;
    color: #cfced3;
  }

  .Scene_Edit__UmOGF {
    color: #fff;
  }

  .Scene_Edit__UmOGF:hover {
    color: #fff;
  }

  .Scene_Action__lBfPA {
    font-size: 1rem;
  }

  .Scene_Bold__QLnGP {
    font-weight: 700;
  }

  .Scene_ShotInfo__uvomD {
    background-color: rgb(226, 250, 255);
  }

.Scene_ShotEditForm__FElif {
  border-bottom: 1px solid rgb(46, 46, 46);
}

.Scene_AliceBlueMild__-NjJr {
  background-color: rgb(252, 253, 253);
}

.Scene_Black__yBsZ5 {
  color: #000;
  font-weight: 700;
}

.Scene_Fancyback__CwWTk {
  background-color: blueviolet;
  color: #fff;
  /* border: 5px solid aqua; */
}

.Scene_FancyTop__OHHZG {
  background-color: #000;
  color: #fff;
}

.Scene_CastEntered__Um\\+9m {
  background-color: #deedfa;
  min-height: 40px;
}

.Scene_Width__J1Tof {
  width: 50%;
}

.Scene_Width95__6dtU- {
  width: 95%;
}

.Scene_Width2__3CCks {
  width: 80%;
}

.Scene_Width3__e\\+a79 {
  width: 80%;
}

.Scene_Dept__1vLSt {
  cursor: pointer;
  border: 5px solid #fff;
  background-color: rgb(228, 245, 250);
  transition-timing-function: ease;
  transition: border .5s, background-color .5s, transform .5s;
}

.Scene_Dept__1vLSt:hover {
  background-color: rgb(181, 223, 236);
  transform: scale(1.1); 
}

.Scene_Card__R\\+hCh i {
  color: #fff;
}

.Scene_ContactBack__sQeba {
  background-color: #dff3f4;
}

.Scene_dropdown-menu__SGh20 {
/* height: 400px; */
overflow-y: scroll;
}

.Scene_DropButt__IeMZg {
  /* height: 500px; */
  overflow-y: scroll; 
}

@media screen and (max-width: 770px) {
    .Scene_Camera1__Q-4YW {
  color: #750b66;
  font-size: 1.2rem;
}
.Scene_Camera2__i-vhf {
  color: #06643a;
  font-size: 1.2rem;
}

  .Scene_Dept__1vLSt {
  height: 70px;
  }

  h5 {
    font-size: 1rem;
  }
  .Scene_InfoBack__I1oqL p {
    font-size: .75rem;
  }

  .Scene_Title__3FAEL {
    font-size: .75em;
  }

  .Scene_Titledetail__kYQJq {
    font-size: 1.25em;
  }

  .Scene_Titlelist__IJFkr {
    font-size: 1em;
  }

  .Scene_SceneTitle__lDw2X {
    font-size: 1.25em;
  }
}

@media screen and (max-width: 600px) {
  .Scene_Div10__GHiSc {
    height: 20px;
    overflow: hidden;
  }

  .Scene_Div25__NETU6 {
    height: 15px;
    overflow: hidden;
  }

  .Scene_Grey4__pVzki {
  font-size: .65rem !important;
  }

.Scene_MoodTopRow__bMKlP {
  height: 50px;
  }

  .Scene_Dept__1vLSt {
  height: 50px;
  }

.Scene_InputBar__zoQvD {
    height: 20px !important;
    font-size: .75rem !important;
}

.Scene_Input__tf1wQ {
  height: 20px !important;
  text-align: center;
  font-size: .75rem !important;
}

.Scene_InputScene__7ixEj {
  font-size: .75rem !important;
 }

 .Scene_InputEx__E92Xz {
  font-size: .75rem !important;
  height: 20px !important;
 }

.Scene_BoldScene__TqC1g {
  font-size: .75rem !important;
}

.Scene_Bold__QLnGP {
  font-size: .75rem !important;
}

.Scene_Span100__otjeH {
  font-size: .85rem;
}

.Scene_SubTitleMood__CdMBQ {
  font-size: .85rem;
}

p {
    font-size: .75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Scene.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;EACb;;AAEF;AACA,WAAW;AACX;;AAEA;AACA,WAAW;AACX,gBAAgB;AAChB;;AAEA;AACA,WAAW;AACX,gBAAgB;AAChB;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;AAEF;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,2DAA2D;EAC3D,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;EACxB,aAAa;AACf;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB;8BAC4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;EACnB;8BAC4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;CACC;6BAC4B;CAC5B,gCAAgC;CAChC,0BAA0B;EACzB,4BAA4B;EAC5B,2BAA2B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;EACzB,4BAA4B;EAC5B,2BAA2B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;CACjB,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;EACzB,4BAA4B;EAC5B,2BAA2B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;AACf;;AAEA;AACA,mBAAmB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EAGpC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;EAEE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;;AAEF;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EAGpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;AACA,mBAAmB;AACnB,kBAAkB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;IACI;EACF,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;EAEE;EACA,YAAY;EACZ;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;EACA,4BAA4B;EAC5B;;AAEF;EACE,YAAY;EACZ;;EAEA;EACA,YAAY;EACZ;;AAEF;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;CAC7B;;CAEA;EACC,4BAA4B;EAC5B,uBAAuB;CACxB;;AAED;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,iBAAiB;EACnB;AACF","sourcesContent":[".Frame {\n  height: 1000px; \n}\n\n.SubTitleGreySilver {\n  background-color: #7a7d7d;\n  background-color: #868889;\n  font-weight: 700;\n  color: #fff;\n}\n\n.SubTitleG {\n  background-color: #5a9fa9;\n  font-weight: 700;\n  color: #fff;\n}\n\n.SubTitleScene {\n  background-color: #39606e;\n  font-weight: 700;\n  color: #fff;\n}\n\n.SubTitleGreyBlue {\n  background-color: #546c88;\n  font-weight: 700;\n  color: #fff;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.Red2 {\n  color: red;\n}\n\n.SceneCard {\n  margin: auto;\n  border: 1px solid #cef3f8;\n  background-color: #39606e;\n  color: #fff;\n}\n\n.SceneCard:hover {\n  background-color: #1ea7ae;\n}\n\n.WhiteForm {\n  background-color: #fff;\n  border-left: 1px solid rgba(129, 102, 21, 0.99);\n  border-right: 1px solid rgba(129, 102, 21, 0.99);\n  border-bottom: 1px solid rgba(129, 102, 21, 0.99);\n  border-top: 1px solid rgba(129, 102, 21, 0.99);\n}\n\n.SubTitleBlack{\n  background-color: #000;\n  color: #fff;\n  font-weight: 700;\n}\n\n.Role {\n  color: #494d70;\n}\n\n.Camera1 {\n  color: #8b0f87;\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n.Camera2 {\n  color: hsl(270, 94%, 33%);\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.BoldTitle2 {\n  font-weight: 700;\n  border-right : 3px solid #fafafa;\n  background-color: #d6fcff;\n}\n\n.BoldTitle3 {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.MoodTopRow {\n  height: 60px;\n  overflow: hidden;\n}\n\n.Icon i {\n  font-size: .6rem;\n}\n\n.Datetext {\n  background-color: #000;\n  color: #fff;\n}\n\n.Date2 {\n  font-size: .6rem;\n}\n\n.SceneCard i {\n  color: #fff;\n}\n\n.Italics {\n    font-style: italic;\n    color: #fff;\n  }\n\n.Grey {\ncolor: #fff;\n}\n\n.Grey2 {\ncolor: #fff;\nfont-weight: 700;\n}\n\n.Grey3 {\ncolor: #fff;\nfont-weight: 700;\n}\n\n.Grey4 {\ncolor: #fff;\nfont-style: italic;\nfont-weight: 700;\nfont-size: .85rem;\n}\n\n.Div60 {\n    height: 60px;\n    overflow: hidden;\n  }\n\n  .Div50 {\n    height: 50px;\n    overflow: hidden;\n  }\n\n  .Div30 {\n    min-height: 30px;\n    overflow: hidden;\n    color: #494d70;\n  }\n\n  .Div10 {\n    height: 10px;\n    overflow: hidden;\n  }\n\n  .Div20 {\n    height: 20px;\n    overflow: hidden;\n  }\n\n  .Div25 {\n    height: 25px;\n    overflow: hidden;\n  }\n\n  .Action2 {\n    color: rgb(54, 52, 52);\n    font-style: italic;\n  }\n\n.WhiteReq {\n  background-color: #fff;\n  color: rgb(140, 111, 25, 99%);\n  font-weight: 700;\n  font-size: .75rem;\n  border-radius: 25px;\n  background-color: #39606e;\n  color: #fff;\n}\n\n.Read {\n  color: rgb(140, 111, 25, 99%);\n  color: #000;\n  color: #fff;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Number {\n  font-weight: 400 !important;\n  font-style: italic;\n}\n\n.Red {\n  color: #00d1ff;\n}\n\n.SubTitle6 {\n    background-color: #010f13;\n    padding: 20px;\n    color: #fff;\n    font-size: 1.25rem;\n}\n\n.Dept {\n  cursor: pointer;\n  border: 5px solid #fff;\n  background-color: rgb(228, 245, 250);\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n  margin-top: 20px;\n  border: 1px solid rgb(140, 111, 25, 99%);\n  background-size: contain;\n  height: 125px;\n}\n\n/* .GoToScene:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n} */\n\n.Title {\n  font-size: 1em;\n}\n\n.White2 {\n  color: #fff;\n}\n\n.WhiteText {\n  color: #fff;\n  font-size: .70rem;\n}\n\n.Small {\n  font-size: .65rem;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.SmallInfo {\n  font-size: .75rem;\n  font-style: italic;\n}\n\n.SmallDepts {\n  font-size: .8rem;\n  font-weight: 700;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.CardBox2 {\n  margin-top: 20px;\n  border: 1px solid rgb(140, 111, 25, 99%);\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n  background-size: contain;\n}\n\n.CardBox3 {\n  margin-top: 20px;\n  border: 2px solid aqua;\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.GoldRead {\n  color: rgb(140, 111, 25, 99%);\n  font-size: .75rem;\n  background-color: #fff;\n}\n\n.BlackRead {\n  background-color: #000;\n  color: #fff;\n  font-size: .75rem;\n}\n\n.WhiteRead {\n  background-color: #fff;\n  color: rgb(140, 111, 25, 99%);\n  color: #000;\n  font-size: .75rem;\n}\n\n.Open {\n  background-color: #fff;\n  color: rgb(140, 111, 25, 99%);\n  font-size: .75rem;\n  font-weight: 700;\n}\n\n.BlueReq {\n  background-color: #fff;\n  color: #000;\n  font-weight: 700;\n  font-size: .75rem;\n}\n\n.WhiteReq:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n}\n\n.WhiteBackReq {\n  background-color: #fff;\n  color: rgb(31, 202, 202);\n  font-weight: 700;\n  font-size: .75rem;\n}\n\n.WhiteBackReq:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n}\n\n.AquaReq {\n  background-color: aqua;\n  color: rgb(140, 111, 25, 99%);\n  font-weight: 700;\n  font-size: .75rem;\n}\n\n.AquaReq:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n}\n\n.AquaWork {\n  background-color: rgb(120, 240, 240);\n  color: rgb(140, 111, 25, 99%);\n  font-weight: 700;\n  font-size: .75rem;\n}\n\n.AquaWork:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n}\n\n.AquaFin {\n  background-color: aqua;\n  color: rgb(140, 111, 25, 99%);\n  font-weight: 700;\n  font-size: .75rem;\n}\n\n.AquaFin:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n}\n\n.BlackReq {\n  background-color: #212529;\n  color: #fff;\n  font-size: .75rem;\n}\n\n.BlackReq:hover {\n  background-color: #fff;\n  color: #000;\n  cursor: pointer;\n}\n\n.BlackWor {\n  background-color: #2f363c;\n  color: #fff;\n  font-size: .75rem;\n}\n\n.BlackWor:hover {\n  background-color: #fff;\n  color: #000;\n  cursor: pointer;\n}\n\n.BlackFin {\n  background-color: #3b444b;\n  color: #fff;\n  font-size: .75rem;\n}\n\n.Blackfin:hover {\n  background-color: #fff;\n  color: #000;\n  cursor: pointer;\n}\n\n.InfoBack {\n  background-color: #fff;\n}\n\n.InfoBack p {\n  font-size: .75rem;\n}\n\n.Italic {\n  font-style: italic;\n}\n\n.Rolem {\n  color: #747686;\n}\n\n.ViewScript {\n  color: rgb(31, 203, 203);\n  font-style: italic;\n}\n\n.ViewScript:hover {\n  color: #228087;\n  cursor: pointer;\n}\n\n.Para {\n  min-height: 25px;\n}\n\n.Para2 {\n  font-size: .75rem !important;\n  color: rgb(140, 111, 25, 99%) !important;\n}\n\n.BoldSceneLight {\n  color: rgb(140, 111, 25, 99%);\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.BoldSceneI {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n  font-style: italic;\n}\n\n.Input {\n  background: #ffffff;\n  /* border: 1px solid #e0e3eb;\n  border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding: 0px 10px;\n  height: 30px !important;\n  text-align: center;\n  color: #494d70;\n\n}\n\n.InputEx {\n  background: #ffffff;\n  /* border: 1px solid #dee1f7;\n  border: 1px solid #c1f1f7; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 30px;\n  height: 30px !important;\n  text-align: center;\n  color: #494d70;\n}\n\n.InputScene {\n /* background: #ffffff;\n border: 1px solid #c1f1f7; */\n border-bottom: 1px #00d1ff solid;\n border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n padding: 0px 10px;\n text-align: center;\n min-height: 30px !important;\n color: #494d70;\n}\n\n.InputGuide {\n background: #ffffff;\n /* border: 1px solid #e0e3eb; */\n border-bottom: 1px #00d1ff solid;\n border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n padding: 0px 10px;\n min-height: 30px !important;\n color: #494d70;\n}\n\n.InputChar {\n background: #ffffff;\n /* border: 1px solid #e0e3eb; */\n border-bottom: 1px #00d1ff solid;\n border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n box-sizing: border-box;\n border-radius: 2px;\n padding: 0px 0px;\n height: 30px !important;\n text-align: center;\n color: #494d70;\n}\n\n.InputArea {\nbackground: #ffffff;\n  /* border: 1px solid #e0e3eb; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding: 0px 10px;\n  height: 50px !important;\n  text-align: center;\n  color: #494d70;\n}\n\n.InputBar {\n  background: #ffffff;\n  border: 1px solid #e0e3eb;\n  box-sizing: border-box;\n  border-radius: 20px;\n  color: #494d70;\n  padding: 0px 10px;\n  margin-bottom: 16px;\n  height: 30px !important;\n}\n\n.InputCharEdit {\n  background: #ffffff;\n  /* border: 1px solid #e0e3eb; */\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding: 0px 10px;\n  height: 25px !important;\n  text-align: center;\n  color: #494d70;\n} \n\n.BoldBlack {\n  color: #000;\n  font-weight: 700;\n}\n\n.Back {\n  background-color: #fff;\n}\n\n.Back1 {\n  background-color: #ddf3f8;\n}\n\n.Break {\n  border-top: 10px solid #d0d9db;\n}\n\n.BreakBlack {\n  border-top: 5px solid #000;\n}\n\n\n.XXX {\n  border-top: 5px solid #edc380;\n  border-top: 5px solid rgb(232, 246, 231);\n  border-top: 5px solid rgb(178, 186, 191);\n}\n\n.Break1 {\n  border-top: 1px solid #d0d9db;\n}\n\n.Break2 {\n  border-top: 5px solid #d0d9db;\n}\n\n.Break3 {\n  border-top: 1px solid #c1f1f7;\n}\n\n.BorderRight {\n  border-right: 1px solid #a7e9f2;\n}\n\n.ColHeight {\n  min-height: 88.8px;\n}\n\n.DeptImageBox {\n  background-color: #000;\n  color: #fff;\n  font-size: .60rem;\n}\n\n.DeptImageBox:hover {\n  background-color: #fff;\n  color: #000;\n  cursor: pointer;\n}\n\n.TitleBox {\n  background-color: #e8f0f1;\n  color: #333;\n}\n\n.TitleBox2 {\n  border-right : 2px solid #fafafa;\n  color: #333;\n}\n\n.TitleBox3 {\n  border-left : 1px solid #72dbe2;\n  border-bottom : 1px solid #72dbe2;\n  color: #333;\n  font-weight: 700;\n}\n\n.TitleBox4 {\n  border-left : 1px solid #72dbe2;\n  border-right : 1px solid #72dbe2;\n  border-bottom : 1px solid #72dbe2;\n  color: #333;\n  font-weight: 700;\n}\n\n.TitleBox4 i {\n  color: #333;\n  font-weight: 700;\n}\n\n.TitleBox5 {\n  border-bottom : 1px solid #72dbe2;\n  color: #333;\n}\n\n.Images {\n  object-fit: cover;\n  height: 200px;\n  width: 100%;\n}\n\n.White {\n  background-color: #fff;\n  min-height: 30px;\n}\n\n.Crimson {\n  color: rgb(231, 64, 97);\n}\n\n.Header {\n  background-color: #fff;\n}\n\n.Header i {\n  color: #666;\n}\n\n.AddScene {\n  background-color: cornsilk;\n}\n\n.Bold { \n  font-weight: 700;\n}\n\n.Lightgrey {\n  color: rgba(0, 0, 0, .54) \n}\n\n.ButtonLine {\n  background-color: #fff;\n  border-top: 3px solid #fff;\n}\n\n.CharactersTitle {\n  color: rgb(40, 189, 189);\n  font-style: italic;\n}\n\n.CharactersTitle2 {\n  color: rgb(36, 125, 125);\n  font-style: italic;\n}\n\n.Actor {\n  background-color: rgb(227, 246, 246);\n  min-height: 65px;\n}\n\n.Close {\n  color: rgb(32, 201, 201);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.Close:hover {\n  color: rgb(10, 66, 66);\n}\n\n.Crimson {\n  color: crimson;\n}\n\n.Blue {\n  color: rgb(50, 204, 204);\n}\n\n.Close:hover {\n  color: rgb(0, 8, 8);\n}\n\n.CloseIns {\n  color: red;\n}\n\n.CloseIns:hover {\n  color: rgb(231, 226, 226);\n}\n\n.BreakBox {\n  border:1px solid aquamarine;\n  min-height: 100px;\n}\n\n.BreakBoxTitle {\n  color: crimson;\n}\n\n.Titlex {\n  color: #0052cc;\n}\n\n.SubTitlex {\n  background-color: #e1ecec;\n  font-weight: 700;\n  color: rgba(0, 0, 0, .54)\n}\n\n.SubTitleMood {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.SubTitle2   {\n  background-color: #d6fcff;\n  font-weight: 700;\n}\n\n.SubTitle3 {\n  background-color: #e4f2f4;\n  font-weight: 700;\n}\n\n.GuideTitle {\n  font-style: italic;\n  background-color: #e8f0f1;\n  color: #104b53;\n}\n\n.GuideText {\n  font-style: italic;\n  color: #24a7b8;\n}\n\n.Guide {\n  background-color: #fff;\n  min-height: 80px;\n}\n\n/* .Button {\n  color: rgb(10, 173, 173);\n}\n\n.Button:hover {\n  color: rgb(9, 182, 182);\n} */\n\n.Button {\n  color: rgb(7, 111, 111);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.Button:hover {\n  color: rgb(2, 38, 38);\n  font-weight: 700;\n}\n\n.Instructions {\n  background-color: aliceblue;\n}\n\n.UniImg {\n  max-height: 130px;\n  cursor: pointer;\n}\n\n.CardBox {\n  margin-top: 20px;\n  border: 1px solid #fff;\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.CardBox:hover {\n  border: 1px solid rgb(255, 255, 255);\n  -webkit-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1); \n}\n\n.CostumeLink {\n  color: rgb(26, 172, 172);\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.CostumeLink:hover {\n  color: rgb(228, 103, 72);\n}\n  \n  .SearchIcon {\n    position: absolute;\n    font-size: 1.2rem;\n    padding: 9px;\n    padding-left: 15px;\n  }\n  \n  .SearchIcon:hover {\n    cursor: default;\n    color: #cfced3;\n  }\n\n  .Edit {\n    color: #fff;\n  }\n\n  .Edit:hover {\n    color: #fff;\n  }\n\n  .Action {\n    font-size: 1rem;\n  }\n\n  .Bold {\n    font-weight: 700;\n  }\n\n  .ShotInfo {\n    background-color: rgb(226, 250, 255);\n  }\n\n.ShotEditForm {\n  border-bottom: 1px solid rgb(46, 46, 46);\n}\n\n.AliceBlueMild {\n  background-color: rgb(252, 253, 253);\n}\n\n.Black {\n  color: #000;\n  font-weight: 700;\n}\n\n.Fancyback {\n  background-color: blueviolet;\n  color: #fff;\n  /* border: 5px solid aqua; */\n}\n\n.FancyTop {\n  background-color: #000;\n  color: #fff;\n}\n\n.CastEntered {\n  background-color: #deedfa;\n  min-height: 40px;\n}\n\n.Width {\n  width: 50%;\n}\n\n.Width95 {\n  width: 95%;\n}\n\n.Width2 {\n  width: 80%;\n}\n\n.Width3 {\n  width: 80%;\n}\n\n.Dept {\n  cursor: pointer;\n  border: 5px solid #fff;\n  background-color: rgb(228, 245, 250);\n  transition-timing-function: ease;\n  transition: border .5s, background-color .5s, transform .5s;\n}\n\n.Dept:hover {\n  background-color: rgb(181, 223, 236);\n  -webkit-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1); \n}\n\n.Card i {\n  color: #fff;\n}\n\n.ContactBack {\n  background-color: #dff3f4;\n}\n\n.dropdown-menu {\n/* height: 400px; */\noverflow-y: scroll;\n}\n\n.DropButt {\n  /* height: 500px; */\n  overflow-y: scroll; \n}\n\n@media screen and (max-width: 770px) {\n    .Camera1 {\n  color: #750b66;\n  font-size: 1.2rem;\n}\n.Camera2 {\n  color: #06643a;\n  font-size: 1.2rem;\n}\n\n  .Dept {\n  height: 70px;\n  }\n\n  h5 {\n    font-size: 1rem;\n  }\n  .InfoBack p {\n    font-size: .75rem;\n  }\n\n  .Title {\n    font-size: .75em;\n  }\n\n  .Titledetail {\n    font-size: 1.25em;\n  }\n\n  .Titlelist {\n    font-size: 1em;\n  }\n\n  .SceneTitle {\n    font-size: 1.25em;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .Div10 {\n    height: 20px;\n    overflow: hidden;\n  }\n\n  .Div25 {\n    height: 15px;\n    overflow: hidden;\n  }\n\n  .Grey4 {\n  font-size: .65rem !important;\n  }\n\n.MoodTopRow {\n  height: 50px;\n  }\n\n  .Dept {\n  height: 50px;\n  }\n\n.InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n}\n\n.Input {\n  height: 20px !important;\n  text-align: center;\n  font-size: .75rem !important;\n}\n\n.InputScene {\n  font-size: .75rem !important;\n }\n\n .InputEx {\n  font-size: .75rem !important;\n  height: 20px !important;\n }\n\n.BoldScene {\n  font-size: .75rem !important;\n}\n\n.Bold {\n  font-size: .75rem !important;\n}\n\n.Span100 {\n  font-size: .85rem;\n}\n\n.SubTitleMood {\n  font-size: .85rem;\n}\n\np {\n    font-size: .75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Frame": `Scene_Frame__-11cT`,
	"SubTitleGreySilver": `Scene_SubTitleGreySilver__9Ppgr`,
	"SubTitleG": `Scene_SubTitleG__Ad4Eo`,
	"SubTitleScene": `Scene_SubTitleScene__P-Pbj`,
	"SubTitleGreyBlue": `Scene_SubTitleGreyBlue__qrgma`,
	"SubTitle": `Scene_SubTitle__gZeDJ`,
	"Red2": `Scene_Red2__8K7YA`,
	"SceneCard": `Scene_SceneCard__9uuoo`,
	"WhiteForm": `Scene_WhiteForm__0CMc5`,
	"SubTitleBlack": `Scene_SubTitleBlack__OqPRS`,
	"Role": `Scene_Role__StIJH`,
	"Camera1": `Scene_Camera1__Q-4YW`,
	"Camera2": `Scene_Camera2__i-vhf`,
	"BoldTitle": `Scene_BoldTitle__XPwUP`,
	"BoldTitle2": `Scene_BoldTitle2__i0IBb`,
	"BoldTitle3": `Scene_BoldTitle3__K+8eK`,
	"MoodTopRow": `Scene_MoodTopRow__bMKlP`,
	"Icon": `Scene_Icon__bg4qX`,
	"Datetext": `Scene_Datetext__OEZnu`,
	"Date2": `Scene_Date2__UV3KN`,
	"Italics": `Scene_Italics__HXF9b`,
	"Grey": `Scene_Grey__lxsQc`,
	"Grey2": `Scene_Grey2__B2GZo`,
	"Grey3": `Scene_Grey3__l6Ojj`,
	"Grey4": `Scene_Grey4__pVzki`,
	"Div60": `Scene_Div60__ya3D+`,
	"Div50": `Scene_Div50__te6Ga`,
	"Div30": `Scene_Div30__wZHOf`,
	"Div10": `Scene_Div10__GHiSc`,
	"Div20": `Scene_Div20__i0JW4`,
	"Div25": `Scene_Div25__NETU6`,
	"Action2": `Scene_Action2__6-SnN`,
	"WhiteReq": `Scene_WhiteReq__EBu4y`,
	"Read": `Scene_Read__HDtQr`,
	"BreakTitle": `Scene_BreakTitle__ZZ2Jh`,
	"Number": `Scene_Number__Wi8g5`,
	"Red": `Scene_Red__KGXIJ`,
	"SubTitle6": `Scene_SubTitle6__DYcz3`,
	"Dept": `Scene_Dept__1vLSt`,
	"Title": `Scene_Title__3FAEL`,
	"White2": `Scene_White2__+Nqif`,
	"WhiteText": `Scene_WhiteText__gB51s`,
	"Small": `Scene_Small__oVQlB`,
	"SmallInfo": `Scene_SmallInfo__kDEwe`,
	"SmallDepts": `Scene_SmallDepts__NJqXA`,
	"CardBox2": `Scene_CardBox2__ZXGWP`,
	"CardBox3": `Scene_CardBox3__Wqs0q`,
	"GoldRead": `Scene_GoldRead__48Mzm`,
	"BlackRead": `Scene_BlackRead__FHkui`,
	"WhiteRead": `Scene_WhiteRead__6esE7`,
	"Open": `Scene_Open__KBSKh`,
	"BlueReq": `Scene_BlueReq__FkQV7`,
	"WhiteBackReq": `Scene_WhiteBackReq__SYUy7`,
	"AquaReq": `Scene_AquaReq__mYelO`,
	"AquaWork": `Scene_AquaWork__ZkklM`,
	"AquaFin": `Scene_AquaFin__w0aOe`,
	"BlackReq": `Scene_BlackReq__h+7EQ`,
	"BlackWor": `Scene_BlackWor__Mw+z5`,
	"BlackFin": `Scene_BlackFin__9rVuI`,
	"Blackfin": `Scene_Blackfin__Hw-Xq`,
	"InfoBack": `Scene_InfoBack__I1oqL`,
	"Italic": `Scene_Italic__ETQx3`,
	"Rolem": `Scene_Rolem__Llfyx`,
	"ViewScript": `Scene_ViewScript__dPgWb`,
	"Para": `Scene_Para__cgPgm`,
	"Para2": `Scene_Para2__GsL23`,
	"BoldSceneLight": `Scene_BoldSceneLight__odtI9`,
	"BoldScene": `Scene_BoldScene__TqC1g`,
	"BoldSceneI": `Scene_BoldSceneI__EYXP+`,
	"Input": `Scene_Input__tf1wQ`,
	"InputEx": `Scene_InputEx__E92Xz`,
	"InputScene": `Scene_InputScene__7ixEj`,
	"InputGuide": `Scene_InputGuide__gpT+B`,
	"InputChar": `Scene_InputChar__N4a2n`,
	"InputArea": `Scene_InputArea__pVpN8`,
	"InputBar": `Scene_InputBar__zoQvD`,
	"InputCharEdit": `Scene_InputCharEdit__HZIqB`,
	"BoldBlack": `Scene_BoldBlack__Dm8zg`,
	"Back": `Scene_Back__B4d23`,
	"Back1": `Scene_Back1__UT6tY`,
	"Break": `Scene_Break__N3xFF`,
	"BreakBlack": `Scene_BreakBlack__vEpN9`,
	"XXX": `Scene_XXX__Uq8zF`,
	"Break1": `Scene_Break1__bsFDh`,
	"Break2": `Scene_Break2__xxVU5`,
	"Break3": `Scene_Break3__Daeib`,
	"BorderRight": `Scene_BorderRight__P4wN6`,
	"ColHeight": `Scene_ColHeight__tCJza`,
	"DeptImageBox": `Scene_DeptImageBox__se++n`,
	"TitleBox": `Scene_TitleBox__wXjcQ`,
	"TitleBox2": `Scene_TitleBox2__CVvur`,
	"TitleBox3": `Scene_TitleBox3__xLVOZ`,
	"TitleBox4": `Scene_TitleBox4__ngdZ1`,
	"TitleBox5": `Scene_TitleBox5__5ZaTf`,
	"Images": `Scene_Images__Ar2Sv`,
	"White": `Scene_White__C3JKf`,
	"Crimson": `Scene_Crimson__G8TQN`,
	"Header": `Scene_Header__YTrAY`,
	"AddScene": `Scene_AddScene__jxpFi`,
	"Bold": `Scene_Bold__QLnGP`,
	"Lightgrey": `Scene_Lightgrey__xmJvu`,
	"ButtonLine": `Scene_ButtonLine__irHS3`,
	"CharactersTitle": `Scene_CharactersTitle__RLjMs`,
	"CharactersTitle2": `Scene_CharactersTitle2__+8SxA`,
	"Actor": `Scene_Actor__aYR2-`,
	"Close": `Scene_Close__XFP2T`,
	"Blue": `Scene_Blue__ap1Rd`,
	"CloseIns": `Scene_CloseIns__V6T4z`,
	"BreakBox": `Scene_BreakBox__-xSmE`,
	"BreakBoxTitle": `Scene_BreakBoxTitle__DyK7s`,
	"Titlex": `Scene_Titlex__jMQs3`,
	"SubTitlex": `Scene_SubTitlex__fadt4`,
	"SubTitleMood": `Scene_SubTitleMood__CdMBQ`,
	"SubTitle2": `Scene_SubTitle2__29NFV`,
	"SubTitle3": `Scene_SubTitle3__MZc2X`,
	"GuideTitle": `Scene_GuideTitle__dkGlL`,
	"GuideText": `Scene_GuideText__Qz7QU`,
	"Guide": `Scene_Guide__UROP9`,
	"Button": `Scene_Button__lgYiv`,
	"Instructions": `Scene_Instructions__L79P5`,
	"UniImg": `Scene_UniImg__Ng6Dz`,
	"CardBox": `Scene_CardBox__e7RKL`,
	"CostumeLink": `Scene_CostumeLink__UwAf2`,
	"SearchIcon": `Scene_SearchIcon__CEZZX`,
	"Edit": `Scene_Edit__UmOGF`,
	"Action": `Scene_Action__lBfPA`,
	"ShotInfo": `Scene_ShotInfo__uvomD`,
	"ShotEditForm": `Scene_ShotEditForm__FElif`,
	"AliceBlueMild": `Scene_AliceBlueMild__-NjJr`,
	"Black": `Scene_Black__yBsZ5`,
	"Fancyback": `Scene_Fancyback__CwWTk`,
	"FancyTop": `Scene_FancyTop__OHHZG`,
	"CastEntered": `Scene_CastEntered__Um+9m`,
	"Width": `Scene_Width__J1Tof`,
	"Width95": `Scene_Width95__6dtU-`,
	"Width2": `Scene_Width2__3CCks`,
	"Width3": `Scene_Width3__e+a79`,
	"Card": `Scene_Card__R+hCh`,
	"ContactBack": `Scene_ContactBack__sQeba`,
	"dropdown-menu": `Scene_dropdown-menu__SGh20`,
	"DropButt": `Scene_DropButt__IeMZg`,
	"Titledetail": `Scene_Titledetail__kYQJq`,
	"Titlelist": `Scene_Titlelist__IJFkr`,
	"SceneTitle": `Scene_SceneTitle__lDw2X`,
	"Span100": `Scene_Span100__otjeH`
};
export default ___CSS_LOADER_EXPORT___;
